module.exports = __webpack_public_path__ + "img/mandala-white.fd15fe54.png";